import { AUTHOR_SEO, DEFAULT_SEO_KEYWORDS } from "./consts";

export function getHomePageSeo(props: {
    assetClasses: Array<{
        name: string;
        description: string;
        url: string;
    }>;
}) {
    const { assetClasses } = props;
    return {
        "@context": "https://schema.org",
        "@type": "WebPage",
        id: "RWA.xyz - Home",
        description:
            "RWA.xyz provides analytics on Tokenized Real-World Assets",
        url: "https://app.rwa.xyz",
        keywords: DEFAULT_SEO_KEYWORDS,
        hasPart: assetClasses.map((assetClass) => ({
            "@type": "WebPage",
            name: assetClass.name,
            url: assetClass.url,
            description: assetClass.description,
            author: AUTHOR_SEO,
        })),
    };
}
